import React from 'react';
import { FC } from 'react';

import SessionConsumptionComponent from './SessionConsumption';

const SessionConsumption: FC = () => {
  return <SessionConsumptionComponent />;
};
export default SessionConsumption;
